import PressCDNLogo from "../../../../src/images/services/presscdn.svg";
import * as React from 'react';
export default {
  PressCDNLogo,
  React
};